<template>
  <div>
    <h1>Política de Privacidad</h1>

    <p>
      Varsity Plaza, haciendo negocios como OW Survey Offline, ("nosotros" "nos"
      "nuestro") se compromete a respetar la privacidad de los usuarios de OW Survey
      Offline App ("Sitio Web") o de nuestras encuestas en línea, incluyendo encuestas de
      elegibilidad ("Encuestas") (El Sitio Web y las Encuestas conjuntamente, el
      "Servicio"). El propósito de esta Política de Privacidad es ayudarle a comprender
      qué información recopilamos cuando utiliza el Servicio, cómo utilizamos dicha
      información y cuándo y con quién podemos compartirla.
    </p>

    <p>
      Esta Política de Privacidad aplica independientemente del dispositivo utilizado para
      acceder a los Servicios (por ejemplo, computadora personal, dispositivo móvil,
      dispositivo electrónico de consumo) y a su uso de las partes públicas de nuestro
      Servicio y los sectores que requieren acceso. Antes de enviar cualquier información
      a través del Servicio, revise esta Política de Privacidad. Mediante el uso de
      cualquier parte del Servicio, incluso convirtiéndose en panelista o realizando
      encuestas en línea, usted acepta la recopilación, el uso, la divulgación y el
      intercambio de información como se describe en esta Política de Privacidad. Podemos
      actualizar esta Política de Privacidad de vez en cuando. Debe consultar esta página
      para obtener actualizaciones. Al continuar utilizando el Servicio constituye su
      acuerdo con la Política de Privacidad actualizada.
    </p>

    <h2>Información Que Recopilamos</h2>

    <p>Información Que Nos Proporciona Directamente</p>

    <p>
      Podemos recopilar su información durante su uso o acceso al Servicio, incluso cuando
      usted:
    </p>

    <ul>
      <li>registra una cuenta;</li>

      <li>participa en una encuesta;</li>

      <li>
        se pone en contacto con nosotros a través correo electrónico o correo postal;
      </li>

      <li>envía un formulario en línea; o</li>

      <li>descarga o utiliza nuestra aplicación móvil;</li>
    </ul>

    <p>
      La información que nos proporcione directamente puede incluir, pero no está limitada
      a: nombre, dirección de correo electrónico, nombre de usuario, contraseña,
      información de respuesta a la encuesta, dirección postal y número de teléfono
      (opcional). También podemos recopilar y mantener los Números de Seguridad Social
      según sea necesario, sólo para propósitos de reportes de impuestos para cualquier
      usuario cuyos puntos y recompensas excedan $600 al año.
    </p>

    <p>
      Respuestas a la encuesta y otras presentaciones. Si participa en encuestas en el
      Servicio, o aplica para participar en dichas encuestas, podemos solicitar de usted
      cierta información. La participación en estas encuestas es completamente voluntaria
      y por lo tanto, usted tiene la opción de divulgar o no esta información a través de
      su participación voluntaria. La información solicitada que puede proporcionarnos
      incluye típicamente antecedentes/información demográfica como código postal, edad,
      hábitos de consumo o información sobre pasatiempos, intereses, situación laboral y
      propiedad del producto ("antecedentes/información demográfica") y respuestas de la
      encuesta a preguntas y problemas de interés para nosotros y para nuestros clientes
      ("información de la respuesta"). También recopilamos cualquier información que
      proporcione al completar y enviar un formulario en línea o al contactarnos por
      correo electrónico o correo postal.
    </p>

    <h2>Información que es Recopilada Automáticamente</h2>

    <p>Información sobre el Dispositivo y el Uso</p>

    <p>
      Cuando utiliza nuestro Servicio, podemos recopilar y analizar automáticamente cierta
      información sobre el equipo o los dispositivos que utiliza para acceder al Servicio
      y su actividad en el Servicio, incluida su dirección IP; información de
      geolocalización; identificadores de dispositivos únicos; las URL que visitó; fecha,
      hora y tiempo dedicados a las páginas visitadas en el Servicio; información sobre su
      navegador y plataforma (por ejemplo, tipos de navegador, sistema operativo); (parte
      de esta información se conoce como "Información de los Archivos de Registro");
      actividad de la cuenta (p.ej. número de entradas); y los datos mostrados o haciendo
      clic (p.ej. elementos de la interfaz de usuario, enlaces).
    </p>

    <h3>Cookies y Otras Tecnologías de Identificación</h3>

    <p>
      De vez en cuando, podemos recopilar datos sobre su uso del Servicio a través de la
      función "cookies" de las aplicaciones principales del navegador, que es un pequeño
      archivo de texto que se coloca en su computadora cuando visita un sitio web y nos
      permite reconocer su computadora. También podemos recopilar o utilizar otras
      tecnologías de identificación tales como píxeles transparentes "rastreadores",
      identificadores de información de sesión u otras tecnologías similares. Podemos
      utilizar cookies y otras tecnologías de identificación para supervisar su uso del
      Servicio, identificarlo o reconocerlo cuando visite el Servicio o participe en
      encuestas particulares u otras oportunidades, ayudarnos a saber que partes del
      Servicio son útiles y cuáles necesitan mejorar, recopilar y analizar información
      estadística (por ejemplo, fecha y hora de las visitas a Nuestro Sitio Web),
      almacenar sus configuraciones, realizar análisis y administrar el Servicio. Puede
      elegir si desea aceptar cookies cambiando la configuración de su navegador. Sin
      embargo, si decide inhabilitar las cookies, sus respuestas a la encuesta no serán
      rastreadas y no recibirá los puntos o recompensas relacionados, y de lo contrario,
      su experiencia con el Servicio podría disminuir significativamente. Podemos
      ofrecerle la oportunidad de participar en encuestas para las cuales un cliente
      requiere cookies adicionales u otras tecnologías de identificación para esas
      encuestas en particular, en cuyo caso se utilizarán para recopilación [información
      similar].
    </p>

    <h2>Cómo Utilizamos Su Información</h2>

    <p>Podemos utilizar su información para los siguientes propósitos:</p>

    <ul>
      <li>para mantener su cuenta;</li>

      <li>para comercializar y prestarle el Servicio;</li>

      <li>
        para enviar invitaciones por correo electrónico o alertas de texto/SMS para
        participar en encuestas;
      </li>

      <li>para determinar su elegibilidad y hacerle coincidir con las encuestas;</li>

      <li>para interpretar los resultados de nuestra encuesta;</li>

      <li>para enviarle puntos y recompensas;</li>

      <li>
        para proporcionar información de antecedentes/información demográfica y de
        respuesta a nuestros clientes en forma agregada/anónima;
      </li>

      <li>para enviarle información sobre su relación o transacciones con nosotros;</li>

      <li>para notificarle sobre las nuevas características u ofertas del Servicio;</li>

      <li>para procesar y responder a sus preguntas;</li>

      <li>para mejorar nuestras ofertas y crear nuevas ofertas;</li>

      <li>para hacer cumplir los términos legales que rigen su uso del Servicio; y</li>

      <li>para administrar y solucionar problemas del servicio.</li>
    </ul>

    <p>
      Podemos agregar y/o despersonalizar la información recolectada a través del Servicio
      para que la información no identifique individualmente a un usuario específico.
      Podemos utilizar datos despersonalizados o agregados para cualquier propósito,
      incluyendo proporcionar perfiles de interés o conjuntos demográficos a nuestros
      clientes o proporcionar información de las respuestas de las encuestas a nuestros
      clientes y para propósitos de investigación y marketing. Podemos compartir estos
      datos con terceros.
    </p>

    <p>
      Podemos enviarle correos electrónicos después de su registro para invitarle a
      participar o alertarle sobre nuestras encuestas, para entregarle puntos y
      recompensas, o para enviarle boletines, actualizaciones y otros avisos de servicio o
      administrativos. Puede optar por excluirse en cualquier momento como se describe a
      continuación en "No Participar".
    </p>

    <h2>Cómo Divulgamos la Información</h2>

    <p>
      Podemos divulgar su información con terceros no afiliados basado en su
      consentimiento. Dicho consentimiento incluye: (a) proporcionar el servicio; (b)
      proporcionar otros servicios que usted ha solicitado; (c) cuando haya concedido
      permiso, o (d) como se establece en esta Política de Privacidad.
    </p>

    <p>
      No vendemos, alquilamos o revelamos información que lo identifique específicamente
      con terceros sin su consentimiento.
    </p>

    <p>
      Divulgamos información de antecedentes/información demográfica e información de
      respuesta en forma agregada y/o despersonalizada con nuestros clientes para su uso
      para investigación de fidedigna del mercado. En estas situaciones, no revelamos a
      estas entidades información que lo identifique personalmente.
    </p>

    <p>
      Podemos proporcionar acceso a su información a terceros que realizan servicios en
      nuestro nombre y para otros fines comerciales legítimos. Estas partes nos brindan
      una variedad de servicios incluyendo, pero no limitado a, procesamiento de pagos,
      almacenamiento de datos, investigación, análisis y servicios legales.
    </p>

    <p>
      También podemos revelar su información para: (a) cumplir con cualquier ley,
      reglamento u orden, como una citación judicial, una orden judicial o una orden de
      registro; (b) proteger y defender nuestros derechos o propiedades, incluidas las
      investigaciones y la defensa de reclamaciones de terceros; (c) o en caso contrario,
      garantizar el cumplimiento de nuestros acuerdos, Términos de Uso y políticas; y/o
      (d) proteger los derechos, la propiedad y la seguridad personal de nuestros
      usuarios, personal o público.
    </p>

    <p>
      Nos reservamos el derecho, en caso de que toda o cualquier parte relevante de
      nuestras acciones, negocios o activos sea transferida a, adquirida por, o fusionada
      con cualquier tercero, para divulgar, transferir o asignar como parte de dicha
      transacción cualquiera o toda la información que hemos recaudado.
    </p>

    <h3>Actualización de Su Cuenta</h3>

    <p>
      Puede cambiar su cuenta o sus configuraciones editando su perfil personal en el
      Servicio. Tales cambios generalmente tienen efecto inmediato. Sin embargo, podemos
      retener cualquier información en la medida requerida por la ley o de otra manera en
      relación con la divulgación de información permitida descrita anteriormente.
    </p>

    <h2>No Participar</h2>

    <p>
      Utilizamos varias herramientas para ayudarnos a entender cómo interactúan los
      usuarios con el Servicio. Estas herramientas nos proporcionan información sobre el
      uso agregado y el tráfico, incluyendo cómo se accedió al Servicio, cuánto tiempo
      permanecieron los visitantes y el número de visitantes por primera vez al Servicio.
      A partir de la fecha de esta Política de Privacidad, utilizamos Google Analytics,
      Hitslink y Safecount. Para obtener más información acerca de Google Analytics y cómo
      utiliza sus datos, visite
      <a target="_blank" href="http://www.google.com/analytics/learn/privacy.html"
        >http://www.google.com/analytics/learn/privacy.html</a
      >. Para obtener más información sobre Hitslink y cómo utiliza sus datos, visite
      <a target="_blank" href="http://www.netapplications.com/privacy.aspx"
        >http://www.netapplications.com/privacy.aspx</a
      >. Para obtener más información sobre Safecount y cómo utiliza sus datos, visite
      <a target="_blank" href="http://www.safecount.net/privacy_faq.php"
        >http://www.safecount.net/privacy_faq.php</a
      >. Usted puede optar por estos servicios a través de los enlaces ubicados dentro de
      sus respectivas declaraciones de política de privacidad.
    </p>

    <p>
      Puede cancelar su membresía haciendo clic en el enlace de cancelación de suscripción
      al pie de cualquier página de nuestro Servicio al iniciar sesión o al pie de los
      correos electrónicos que enviamos o a través de este enlace. Por favor espere
      cuarenta y ocho (48) horas para procesar la solicitud de cancelación de la
      suscripción. Los padres o tutores legales de cualquier miembro que sea menor de
      dieciocho (18) años de manera similar pueden solicitar la cancelación de la cuenta
      de su hijo. Retendremos toda la información recopilada antes de la terminación en
      nuestras bases de datos hasta 60 días.
    </p>

    <h3>Enlaces</h3>

    <p>
      El Servicio y su contenido pueden contener enlaces a sitios web, aplicaciones y
      recursos de terceros. No somos responsables de las prácticas de privacidad ni del
      contenido de estos sitios, servicios o recursos de terceros, y debe consultar las
      declaraciones de privacidad de dichos sitios, servicios y recursos. Por ejemplo,
      mientras está interactuando con uno de los sitios web o servicios de nuestros
      clientes, sus políticas de privacidad rigen la recopilación de su información. No
      somos responsables de cómo nuestros clientes utilizan la información que recopilan
      de usted mientras está en los sitios web o servicios de nuestros clientes.
    </p>

    <h3>Seguridad de Datos</h3>

    <p>
      Nuestro Servicio cuenta con medidas de seguridad que ayudan a prevenir la pérdida,
      el mal uso y la alteración de la información que obtenemos de usted, pero no
      garantizamos nuestra capacidad de prevenir dicha pérdida, uso indebido o alteración
      a usted o a terceros.
    </p>

    <p>
      Le recordamos que debe mantener en la privacidad su nombre de usuario y contraseña.
      No solicitamos contraseñas en correos electrónicos no deseados o llamadas
      telefónicas. Le sugerimos que cierre la sesión de su cuenta y cierre la ventana del
      navegador después de completar una encuesta u otra actividad en el Servicio.
    </p>

    <h3>Cambios a esta Política de Privacidad</h3>

    <p>
      Podemos modificar esta Política de Privacidad, incluyendo el reflejar cambios en
      nuestras prácticas de recopilación y uso de datos, en cualquier momento publicando
      una versión revisada en el Sitio Web. Usted es responsable de revisar regularmente
      el Sitio Web para obtener un aviso oportuno de dichas enmiendas. Se considerará que
      ha aceptado dichas modificaciones al continuar utilizando el Servicio tras la
      publicación de dichas enmiendas. Si no está de acuerdo con cualquiera de estos
      cambios, puede suspender inmediatamente todo acceso y uso del Servicio. Usted acepta
      que dicha suspensión será en tal caso su recurso exclusivo.
    </p>

    <h3>Solicitar la eliminación de datos</h3>

    <p>
      Puede solicitar la eliminación de sus datos directamente poniéndose en contacto con
      nuestro servicio de asistencia en support_owsurvey@offerwise.com. En un plazo de 48
      horas, eliminaremos todos sus datos y le enviaremos una confirmación por correo
      electrónico.
    </p>

    <h3>Usuarios Internacionales — Consentimiento para Transferir a Estados Unidos</h3>

    <p>
      El Sitio Web está alojado y el Servicio se proporciona en los Estados Unidos de
      América y el Servicio se rige por la ley de los Estados Unidos. Si usted es un
      residente de la Unión Europea u otro lugar fuera de los Estados Unidos o está
      accediendo al Servicio desde fuera de los Estados Unidos, por favor tenga en cuenta
      que, a través de su uso del Servicio, la información que proporcione será
      transferida a los Estados Unidos de América y usted autoriza la transferencia. Las
      leyes o reglamentos que rigen la recopilación, uso y divulgación de datos personales
      de los Estados Unidos pueden diferir de las leyes de su jurisdicción. No
      representamos ni garantizamos que el Servicio, o parte de él, sea apropiado o
      disponible para su uso en cualquier jurisdicción en particular. Aquellos que opten
      por acceder al Servicio lo hacen por su propia iniciativa y bajo su propio riesgo y
      son responsables de cumplir con todas las leyes, normas y reglamentos locales.
      Podemos limitar la disponibilidad del Servicio en su totalidad o en parte, a
      cualquier persona, área geográfica o jurisdicción que elijamos, en cualquier momento
      y a nuestra sola discreción.
    </p>

    <p>
      Varsity Plaza, LLC, propietaria del Sitio Web y del Servicio, es una corporación
      constituida bajo las leyes del Estado de Virginia, Estados Unidos.
    </p>

    <h5>Varios</h5>

    <p>
      El Sitio Web y el Servicio no están pensados ni diseñados para atraer a niños
      menores de 13 años. No recopilamos, solicitamos o recibimos información de niños
      menores de 13 años.
    </p>

    <p>La versión en inglés controlará esta Política de privacidad.</p>

    <p>Última Actualización de la Política de Privacidad: 1 de abril de 2022</p>
  </div>
</template>

<script>
export default {
  name: 'Spanish',
}
</script>

<style lang="scss" scoped></style>
